<script>
  export let text;
</script>

<h1>{text}</h1>


<style>
  h1 {
    font-size: 3.4rem;
    font-family: 'Oswald', sans-serif;
    text-align: center;
    padding: 1rem 0 1rem 0;
  }
</style>